<div class="progress-indicator-container">
	<div class="progress-indicator progress-indicator-background"></div>

	<div class="progress-indicator progress-indicator-overlay" [style.width]="value + '%'"></div>
</div>
